import { AP_PATHS } from '../adminPersonnelPaths';

export const NOTIF_UI_TYPE_MAP = {
  ALERT: 'danger',
  WARNING: 'warning',
  SUCCESS: 'success',
  INFO: 'info'
};

export const NOTIF_API_TYPES = ['ALERT', 'INFO', 'WARNING', 'SUCCESS'];

export function mapNotificationFromApi(n) {
  return {
    id: n.id,
    type: NOTIF_UI_TYPE_MAP[n.type] || 'info',
    apiType: n.type,
    title: n.title,
    message: n.message,
    timestamp: n.created_at,
    read: Boolean(n.is_read),
    readAt: n.read_at,
    relatedEntityType: n.related_entity_type,
    relatedEntityId: n.related_entity_id
  };
}

export function formatNotificationTime(timestamp) {
  if (!timestamp) return '—';
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '—';

  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "À l'instant";
  if (diffMins < 60) return `Il y a ${diffMins} min`;
  if (diffHours < 24) return `Il y a ${diffHours} h`;
  if (diffDays < 7) return `Il y a ${diffDays} j`;

  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
  });
}

export function getNotificationIcon(uiType) {
  const icons = {
    info: 'infoCircle',
    success: 'checkCircle',
    warning: 'alertTriangle',
    danger: 'alertCircle'
  };
  return icons[uiType] || 'bell';
}

/** Lien contextuel selon l'entité liée (admin personnel). */
export function getNotificationNavigateTarget(notification) {
  const type = notification.relatedEntityType || notification.related_entity_type;
  if (!type) return null;

  if (type === 'company') return AP_PATHS.COMPANIES;
  if (type === 'member') return AP_PATHS.MEMBERS;
  return null;
}

export function getNotificationActionLabel(notification) {
  const type = notification.relatedEntityType || notification.related_entity_type;
  if (type === 'company') return 'Voir les sociétés';
  if (type === 'member') return 'Voir les adhérents';
  return null;
}
